import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '@bufferapp/ui/Text';
import { Button } from '@bufferapp/ui';

import { CloseButton } from '~/content/components/Editor/styles';
import {
  StyledOverlay,
  ModalWrapper,
  InnerWrapper,
  ButtonWrapper,
  StyledText,
  CloseDialogButton,
} from './styles';

const ConfirmCloseModal = ({
  onCancel,
  onConfirmClose,
}: {
  onCancel: () => void;
  onConfirmClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledOverlay />
      <ModalWrapper onPointerDownOutside={(e) => e.preventDefault()}>
        <InnerWrapper>
          <Text type="h3">{t('content.modals.confirmClose.title')}</Text>
          <StyledText type="p">
            {t('content.modals.confirmClose.description')}
          </StyledText>
          <ButtonWrapper>
            <Button
              type="text"
              label={t('content.modals.confirmClose.cancel')}
              onClick={onCancel}
            />
            <Button
              type="danger"
              label={t('content.modals.confirmClose.confirm')}
              onClick={onConfirmClose}
            />
          </ButtonWrapper>
          <CloseDialogButton asChild>
            <CloseButton size="large" />
          </CloseDialogButton>
        </InnerWrapper>
      </ModalWrapper>
    </>
  );
};

ConfirmCloseModal.propTypes = {};

export default ConfirmCloseModal;
